import React from 'react';
import './FooterNav.css';

export function FooterNav() {
  return (
    <div className="footer-nav">
      <div className="footer-nav__links">
        <a href="/privacy.html" className="footer-nav__link">
          개인정보처리방침
        </a>
        <a href="/terms.html" className="footer-nav__link">
          이용약관
        </a>
        <a href="mailto:aimus1440@gmail.com" className="footer-nav__link">
          문의하기
        </a>
      </div>

      <div className="footer-nav__socials">
        <a
          href="https://www.instagram.com/aimus_archery?igsi=YXphZHVjc2lyZzg="
          target="_blank"
          rel="noopener noreferrer"
          className="footer-nav__social-btn"
          aria-label="AIMERS Instagram"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
            <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
          </svg>
        </a>
      </div>
    </div>
  );
}
